// ApplicationAudit.tsx

import * as React from 'react';
import ApplicationList from './Components/ApplicationList';
import CustomMenu from '../../components/CustomMenu/CustomMenu';

/**
 * 申請審査ページコンポーネント
 * - カスタムメニュー内に申請一覧テーブルを表示する
 */
export default function ApplicationAudit() {
 
  
  return (
   <CustomMenu>
          <ApplicationList/> 
    </CustomMenu>
       
    )}
    